import React, { useMemo } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { View } from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { APP_OPTIONS, TOPICAL_PATH } from '../../../../../config/constants';
import { createSearchFacetUrl } from '../../../../../helpers/createSearchUrl';
import type { TargetAudienceProps } from '..';
import {
  DynamicMediaItem,
  Hero,
  ParagraphsRenderer,
  RelatedArticles,
  RelatedEvents,
} from '../../../../../components';

const TaxonomyTargetAudiencePageChild: React.FC<TargetAudienceProps> = ({ entity }) => {
  const { t } = useTranslation();

  const targetAudience = entity.toJS();
  const name = targetAudience.name[0].value;
  const id = targetAudience.tid[0].value;
  const paragraphs = targetAudience.field_paragraphs;

  const classes = c('TaxonomyTargetAudiencePage', 'TaxonomyTargetAudiencePage--Child');

  const searchUrl = useMemo(() => createSearchFacetUrl({
    pathname: TOPICAL_PATH,
    index: APP_OPTIONS.parameters.searchkitIndexTopical,
    facetType: 'refinementList',
    attribute: 'targetAudience',
    value: name,
  }), [name]);

  return (
    <div className={classes}>
      <Hero
        title={name}
        body={targetAudience.description[0].value || ''}
        media={<DynamicMediaItem media={targetAudience.field_media_item[0]} imageAspectRatio="4_3" aboveTheFold />}
        containMedia={targetAudience.field_media_item[0].bundle === 'svg'}
        background="primary"
      />

      <Container>
        <div className="content-section">
          <div className="row">
            {paragraphs.length > 0 && (
              <div className="col-md-7 mb-12 mb-md-0">
                <ParagraphsRenderer paragraphs={paragraphs} />
              </div>
            )}

            <div className="col-md-5">
              <View
                key={`docs_by_target_audience:${id}`}
                id="docs"
                display="docs_by_target_audience"
                args={[id, 'document']}
                resetStateOnUnmount
              />
            </div>
          </div>
        </div>

        <RelatedEvents
          targetId={id}
          title={t('pages.taxonomy_target_audience_page.child.related_events_title', { targetAudience: name.toLowerCase() })}
          moreUrl={searchUrl}
        />

        <RelatedArticles
          targetId={id}
          display="highlights_large"
          title={t('pages.taxonomy_target_audience_page.child.related_articles_title')}
        />
      </Container>
    </div>
  );
};

export default TaxonomyTargetAudiencePageChild;
